export enum PaymentMethod {
  ApplePay = 1,
  GooglePay = 2,
  Card = 3,
}
